import { Form } from 'antd'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import OnlineScheduleTemplate from 'components/EmailTemplate/OnlineScheduleTemplate'
import OfflineScheduleTemplate from 'components/EmailTemplate/OfflineScheduleTemplate'
import InterviewForm from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewForm'
import ManyToManyPreview from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/ManyToManyPreview/index'
import OneToOnePreview from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/OneToOnePreview/index'
import { FooterFlex } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import { getInterviewerList } from 'modules/Drives/actions'
import {
  getNotificationCatalogues,
  sendNotificationBulkEmail,
  sendNotificationBulkEmailWhatsapp,
} from 'modules/Users/actions'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import ReactDOMServer from 'react-dom/server'
import { useDispatch, useSelector } from 'react-redux'
import SuccessMessage from 'utils/SuccessMessage'
import { permittedEventCruds } from 'utils/permissionsValidation'
import { toCamelCase } from '../../../../../utils/camelCase'
const ScheduleInterview = ({
  scheduleDrawer,
  setScheduleDrawer,
  selectedCandidateId,
  selectedCandidate,
  rolesMetrics,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  selectedRound,
  driveData,
  selectedRoundType,
  candidateDeatils,
  candidateInfoData,
  getCandidateList,
  getRoleMetrics,
  setSelectedCandidateId,
  setSelectedCandidate,
  isSingleOrBulk,
  newForm,
  setnewForm,
  singleRoleData,
  stage,
  status,
  getCandidateScoreList,
  lastPanelId,
  isAllSelected,
  setIsAllSelected,
}) => {
  const { AUTH_URL } = process.env
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [preview, setPreview] = useState(false)
  const [schedulePreview, setSchedulePreview] = useState(false)
  const [check, setCheck] = useState(false)
  const [candidates, setCandidates] = useState(0)
  const [selectedRoundName, setSelectedRoundName] = useState(selectedRound)
  const [interviewType, setInterviewType] = useState('')
  const [interviewMode, setInterviewMode] = useState(null)
  const [isOneDayDrive, setIsOneDayDrive] = useState(false)
  const [linkPanelData, setLinkPanelData] = useState([
    {
      link: '',
      panel: [{ id: null, firstName: null, lastName: null }],
    },
  ])
  const [addedInterviewer, setAddedInterviewer] = useState([])

  const [interviewInfo, setInterviewInfo] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [confirmedResponse, setConfirmedResponse] = useState({})

  const [selectingStartDate, setSelectingStartDate] = useState('')
  const [selectingEndDate, setSelectingEndDate] = useState('')
  const [dateRange, setDateRange] = useState([])
  const [parametersList, setParametersList] = useState([])
  const interviewListData = useSelector(state => state?.drives?.interViewerList)

  const [interviewList, setInterviewList] = useState(interviewListData)

  const order = rolesMetrics[0]?.rounds
    ?.map(({ roundName }) => roundName)
    .indexOf(selectedRoundType?.roundName)

  const isAssesemntType =
    (order === 0 && rolesMetrics[0]?.rounds[0]?.type === 'ASSESMENT') ||
    rolesMetrics[0]?.rounds[0]?.type === 'EXTERNAL_ASSESMENT'

  const dateFormat = 'YYYY-MM-DD'
  const permission = useSelector(state => state?.auth?.permissions)
  const corporateData = useSelector(state => state?.auth?.corporateData)
  const userData = useSelector(state => state?.auth?.userData)
  const [scheduleTemplate, setScheduleTemplate] = useState(null)
  const [scheduleOfflineTemplate, setScheduleOfflineTemplate] = useState(null)
  const [interviewTemplate, setInterviewTemplate] = useState(null)
  const [assessmentWhatsapp, setAssessmentWhatsapp] = useState(null)
  const [assessmentOfflineWhatsapp, setAssessmentOfflineWhatsapp] =
    useState(null)
  const [interviewVirtualWhatsapp, setInterviewVirtualWhatsapp] = useState(null)
  const [interviewCampusWhatsapp, setInterviewCampusWhatsapp] = useState(null)
  let linkPanelInitialValue = {
    link: '',
    panel:
      interviewType === 'ASSESMENT'
        ? [
            {
              id: null,
              firstName: null,
              lastName: null,
            },
          ]
        : [],
  }
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Fresher'
  )

  const Schedule =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''

  useEffect(() => {
    ;(async () => {
      if (Schedule?.id) {
        let responce = await dispatch(getNotificationCatalogues(Schedule?.id))
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Assessment Scheduled' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setScheduleTemplate(filteredArray[0].eventNotificationTemplate)
        }

        const filteredArray1 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Interview Scheduled' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray1?.length > 0) {
          setInterviewTemplate(filteredArray1[0].eventNotificationTemplate)
        }

        const filteredArray2 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'assessment_scheduled_student' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray2?.length > 0) {
          setAssessmentWhatsapp(filteredArray2[0].eventNotificationTemplate)
        }

        const filteredArray3 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_scheduled__virtual_' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray3?.length > 0) {
          setInterviewVirtualWhatsapp(
            filteredArray3[0].eventNotificationTemplate
          )
        }

        const filteredArray4 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_scheduled__campus_and_pool_drive' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray4?.length > 0) {
          setInterviewCampusWhatsapp(
            filteredArray4[0].eventNotificationTemplate
          )
        }

        const filteredArray5 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'assessment_scheduled_student_offline' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray5?.length > 0) {
          setAssessmentOfflineWhatsapp(
            filteredArray5[0].eventNotificationTemplate
          )
        }
        const filteredArray6 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Assessment Scheduled Offline' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray6?.length > 0) {
          setScheduleOfflineTemplate(
            filteredArray6[0].eventNotificationTemplate
          )
        }
      }
    })()

    return () => {}
  }, [Schedule])

  useEffect(() => {
    ;(async () => {
      await dispatch(getInterviewerList())
    })()

    return () => {}
  }, [])
  useEffect(() => {
    if (singleRoleData?.interviewParameters?.[stage]) {
      setParametersList(singleRoleData?.interviewParameters?.[stage])
    } else {
      setParametersList([])
    }
  }, [singleRoleData,selectedRound])
  const handleIterviewRound = value => {
    setSelectedRoundName(value)
    form.setFieldsValue({
      interviewRound: value,
    })
  }

  const disabledDate = current => {
    const today = moment().startOf('day')
  
    return current < today
  }
  
  const disabledStartDate = current => {
    // Disable dates before today
    return current && current < moment().startOf('day')
  }
  
  const disabledEndDate = current => {
    const selectedStartDate = moment(selectingStartDate, 'DD/MM/YYYY').startOf('day')
  
    return (
      current < moment().startOf('day') ||
      current < selectedStartDate   
     )
  }
  
  const onChangeStartDate = (date, dateString) => {
    setSelectingStartDate(dateString)
    form.setFieldsValue({
      startDate: moment(dateString, 'DD/MM/YYYY'),
    })
    setSelectingEndDate('')
    form.setFieldsValue({
      endDate: '',
    })
  }

  const onChangeEndDate = (date, dateString) => {
    if (date && dateString) {
    setSelectingEndDate(dateString)
    form.setFieldsValue({
      endDate: moment(dateString, 'DD/MM/YYYY'),
    })
    } else {
      setSelectingEndDate('')
      form.setFieldsValue({
        endDate: null,
      })
    }
  }

  const onChangeDate = (date, dateString) => {
    setDateRange(date)
    form.setFieldsValue({
      dates: dateString,
    })
  }

  const onDurationChange = value => {
    form.setFieldsValue({
      duration: value,
    })
  }

  const onTimeChange = (value, time) => {
    form.setFieldsValue({
      startTime: time,
    })
  }
  const onEndTimeChange = (value, time) => {
    form.setFieldsValue({
      endTime: time,
    })
  }
  const onChangeMode = value => {
    form.setFieldsValue({
      mode: value,
    })
    setInterviewMode(value)
    form.setFieldsValue({
      linkAndPanel: [linkPanelInitialValue],
    })
    setLinkPanelData([
      {
        link: '',
        panel: [{ id: null, firstName: null, lastName: null }],
      },
    ])
  }

  const onChangeLink = (e, index) => {
    let linkAndPanel = linkPanelData
    linkAndPanel[index].link = e.target.value
    setLinkPanelData(linkAndPanel)
    form.setFieldsValue({
      linkAndPanel: linkAndPanel,
    })
  }

  const onClickNone = () => {
    setAddedInterviewer('None')
    setLinkPanelData([
      {
        panel: [{ id: null, firstName: null, lastName: null }],
      },
    ])
    form.setFieldsValue({
      linkAndPanel: [
        {
          panel: [{ id: null, firstName: null, lastName: null }],
        },
      ],
    })
  }

  const getUpdatedList = () => {
    let selectedInterviewer = linkPanelData
      ?.map(({ panel }) => panel)
      .flatMap(data => data)
      ?.map(({ id }) => id)
    let updatedInterviewerList = interviewListData.filter(
      data => !selectedInterviewer.includes(data?._id)
    )
    setInterviewList(updatedInterviewerList)
  }
  const [interviewer, setInterviewer] = useState('')
  const onSelectInterview = (value, option, index) => {
    setInterviewer(value)
    let selectedValue = Array.isArray(value) ? value : [value]
    let selectedOption = Array.isArray(option) ? option : [option]
    selectedValue = selectedValue?.map((item) => {
      let matchedItem = interviewListData?.find(
        (interviewer) => item === interviewer?.first_name + ' ' + interviewer?.last_name || item === interviewer?._id
      );
      return matchedItem?._id || item; // Return matched object or original value
    });
    selectedOption = selectedValue?.map((item) => {
      let matchedItem = interviewListData?.find(
        (interviewer) => item === interviewer?.first_name + ' ' + interviewer?.last_name || item === interviewer?._id
      );
      const result={
        id:matchedItem?._id,
        firstName:matchedItem?.first_name,
        lastName:matchedItem?.last_name,
      }
      return result || item; 
    });
    setAddedInterviewer(
      selectedValue.filter(item => {
        return item !== 'None'
      })
    )

    let selectedData = selectedOption?.map(({ id, firstName, lastName }) => {
      return { id, firstName, lastName }
    })
    let linkAndPanel = linkPanelData.map((data, indx) => {
      if (index === indx) {
        return { ...data, panel: selectedData }
      } else {
        return data
      }
    })

    setLinkPanelData(linkAndPanel)
    form.setFieldsValue({
      linkAndPanel: linkAndPanel,
    })
  }

  const handlePreview = () => {
    if (
      interviewType === 'GROUP' ||
      (interviewType === 'FACE_TO_FACE' && isSingleOrBulk)
    ) {
      setSchedulePreview(true)
      setScheduleDrawer(false)
    } else {
      setPreview(true)
      setScheduleDrawer(false)
    }
  }

  useEffect(() => {
    getDriveInterviewerList(driveId)
  }, [driveId])

  useEffect(() => {
    setSelectedRoundName(
      selectedRound === 'all_candidates'
        ? candidateInfoData?.stage
        : selectedRound
    )
    form.setFieldsValue({
      interviewRound:
        selectedRound === 'all_candidates'
          ? candidateInfoData?.stage
          : selectedRound,
    })
  }, [selectedRound, candidateInfoData])

  const getMode = () => {
    setIsOneDayDrive(driveData?.startDate === driveData?.endDate)
    form.setFieldsValue({
      dates: moment(driveData?.startDate, dateFormat),
    })
    if (interviewType === 'EXTERNAL_ASSESMENT') {
      onChangeMode('EXTERNAL_LINK')
    }
  }
  useEffect(() => {
    getMode()
    if (interviewType === 'EXTERNAL_ASSESMENT') {
      onChangeMode('EXTERNAL_LINK')
    }
  }, [driveData, interviewType])

  useEffect(() => {
    form.setFieldsValue({
      candidatesPerGroup: candidates,
    })
  }, [candidates])

  useEffect(() => {
    if (!preview) {
      setInterviewType(selectedRoundType?.type)
      form.setFieldsValue({
        interviewType: selectedRoundType?.type,
      })
      form.setFieldValue({
        mode: interviewMode,
      })
    }
  }, [selectedRoundType, scheduleDrawer])

  useEffect(() => {
    setInterviewList(interviewListData)
  }, [interviewListData])

  const onSubmitFormData = async values => {
    const dates = isAssesemntType
      ? [
          moment(values?.startDate).format('YYYY-MM-DD'),
          moment(values?.endDate).format('YYYY-MM-DD'),
        ]
      : moment(dateRange[0]).format('YYYY-MM-DD') ===
        moment(dateRange[1]).format('YYYY-MM-DD')
      ? [moment(dateRange[0]).format('YYYY-MM-DD')]
      : [
          moment(dateRange[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
          moment(dateRange[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
        ]

    if (
      interviewType === 'ASSESMENT' ||
      interviewType === 'EXTERNAL_ASSESMENT'
    ) {
      setInterviewInfo({ ...values, dates: dates })
      setnewForm(false)
      handlePreview()
    } else {
      setInterviewInfo({ ...values, dates: dates })
      setnewForm(false)
      scheduleInterview(false, { ...values, dates: dates })
    }
  }

  const getLinkAndPanelValue = value => {
    let updatedList = []
    if (interviewMode === 'OFFLINE') {
      updatedList = value.map(({ panel }) => {
        return { panel: panel }
      })
    } else if (
      (interviewType === 'ASSESMENT' ||
        interviewType === 'EXTERNAL_ASSESMENT') &&
      interviewMode === 'EXTERNAL_LINK'
    ) {
      updatedList = value.map(({ link }) => {
        return {
          link: link,
          panel: [{ id: null, firstName: null, lastName: null }],
        }
      })
    } else {
      updatedList = value
    }

    return updatedList
  }

  const typeLabels = {
    ASSESMENT: 'Assessment',
    GROUP: 'Group Discussion',
    FACE_TO_FACE: 'Interview',
    EXTERNAL_ASSESMENT: 'External Assessment',
  }
  const labelText = typeLabels[selectedRoundType?.type] || ''
  const messageType = toCamelCase(labelText)
  const scheduleInterview = async (isConfirm, values) => {
    const dates = isAssesemntType
      ? [
          moment(values?.startDate).format('YYYY-MM-DD'),
          moment(values?.endDate).format('YYYY-MM-DD'),
        ]
      : moment(dateRange[0]).format('YYYY-MM-DD') ===
        moment(dateRange[1]).format('YYYY-MM-DD')
      ? [moment(dateRange[0]).format('YYYY-MM-DD')]
      : [
          moment(dateRange[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
          moment(dateRange[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
        ]

    setIsLoading(true)

    const feedback = parametersList?.map(item => {
      return {
        qp: 0,
        type: item,
        value: 0,
      }
    })

    let payload = {
      ...values,
      forAllCandidate: isAllSelected,
      isconfirmed: isConfirm,
      candidatesPerGroup:
        interviewType !== 'GROUP' ? 1 : values?.candidatesPerGroup,

      dates: dates,
      studentIds: isSingleOrBulk
        ? selectedCandidate.map(data => {
            return { studentId: data?.student?.id }
          })
        : [{ studentId: selectedCandidateId[0] }],
      linkAndPanel: getLinkAndPanelValue(values?.linkAndPanel),
      time:
        (interviewType === 'ASSESMENT' ||
          interviewType === 'EXTERNAL_ASSESMENT') &&
        interviewMode === 'EXTERNAL_LINK'
          ? '00:00:00'
          : values.time,
      mode: values?.mode?.includes('EXTERNAL_LINK')
        ? 'EXTERNAL_LINK'
        : values?.mode,
      feedback:
        interviewType != 'ASSESMENT' || interviewType != 'EXTERNAL_ASSESMENT'
          ? feedback
          : [],
      parameters: parametersList,
      forScheduleORReschedule:
        status == 'SCHEDULED,TO_BE_SCHEDULED'
          ? check
            ? 'BOTH'
            : 'SCHEDULE'
          : 'RESCHEDULE',
    }

    let response = await createInterview(driveId, roleId, payload)
    if (response?.status >= 200 && response?.status <= 300) {
      setIsLoading(false)
      if (isConfirm) {
        SuccessMessage(`${messageType} scheduled successfully!`)
        setScheduleDrawer(false)
        form.resetFields()
        setInterviewInfo({})
        form.setFieldsValue({ interviewRound: selectedRoundName })
        form.setFieldsValue({ mode: interviewMode })
        // setCandidates(0)
        // form.setFieldsValue({
        //   candidatesPerGroup: 0,
        // })
        getCandidateList()
        getRoleMetrics(driveId, roleId)
        setSelectedCandidateId([])
        setSelectedCandidate([])
        if (setIsAllSelected) {
          setIsAllSelected(false)
        }
        setSelectingStartDate('')
        setSelectingEndDate('')
        setDateRange([])
        setLinkPanelData([
          {
            link: '',
            panel: [{ id: null, firstName: null, lastName: null }],
          },
        ])
        form.setFieldsValue({
          mode: interviewMode,
        })

        const emailMode = payload?.mode || interviewMode
        if (
          (interviewType === 'ASSESMENT' ||
            interviewType === 'EXTERNAL_ASSESMENT') &&
          emailMode === 'EXTERNAL_LINK'
        ) {
          const assessmentLabel = typeLabels[interviewType] || 'Assessment'
          const final = selectedCandidate?.map(item => {
            const htmlBody = ReactDOMServer.renderToString(
              <OnlineScheduleTemplate
                data={{
                  companyName: corporateData?.name,
                  roleName: rolesMetrics[0]?.roleName,
                  assessmentType: assessmentLabel,
                  date: moment(dates[0]).format('DD/MMM/YYYY') + ' - ' + moment(dates[1] || dates[0]).format('DD/MMM/YYYY'),
                  time: (payload?.startTime || '') + (payload?.endTime ? ' - ' + payload?.endTime : ''),
                  link: payload?.linkAndPanel?.[0]?.link || AUTH_URL,
                  note: payload?.instructions || '',
                  signatureName: (userData?.first_name || '') + (userData?.last_name ? ' ' + userData?.last_name : ''),
                  signatureContact: userData?.phone_number || '',
                }}
              />
            )
            return {
              to: item?.student?.studentPersonalProfile?.primaryEmail,
              subject: `${rolesMetrics[0]?.roleName} – Online ${assessmentLabel} Scheduled`,
              htmlBody,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }
        if (
          interviewType === 'ASSESMENT' &&
          emailMode != 'EXTERNAL_LINK'
        ) {
          const assessmentLabel = typeLabels[interviewType] || 'Assessment'
          const final = selectedCandidate?.map(item => {
            const htmlBody = ReactDOMServer.renderToString(
              <OfflineScheduleTemplate
                data={{
                  companyName: corporateData?.name,
                  roleName: rolesMetrics[0]?.roleName,
                  assessmentType: assessmentLabel,
                  date: moment(dates[0]).format('DD/MMM/YYYY'),
                  time: (payload?.startTime || '') + (payload?.endTime ? ' - ' + payload?.endTime : ''),
                  venue: payload?.location || '',
                  note: payload?.instructions || '',
                  signatureName: (userData?.first_name || '') + (userData?.last_name ? ' ' + userData?.last_name : ''),
                  signatureContact: userData?.phone_number || '',
                }}
              />
            )
            return {
              to: item?.student?.studentPersonalProfile?.primaryEmail,
              subject: `${rolesMetrics[0]?.roleName} – ${assessmentLabel} Scheduled`,
              htmlBody,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }
        if (interviewType != 'ASSESMENT' && interviewType != 'EXTERNAL_ASSESMENT') {
          const interviewLabel = typeLabels[interviewType] || 'Interview'
          const isOnline = emailMode === 'EXTERNAL_LINK'
          const final = selectedCandidate?.map(item => {
            let htmlBody
            if (isOnline) {
              htmlBody = ReactDOMServer.renderToString(
                <OnlineScheduleTemplate
                  data={{
                    companyName: corporateData?.name,
                    roleName: rolesMetrics[0]?.roleName,
                    assessmentType: interviewLabel,
                    date: moment(dates[0]).format('DD/MMM/YYYY') + ' - ' + moment(dates[1] || dates[0]).format('DD/MMM/YYYY'),
                    time: (payload?.startTime || '') + (payload?.endTime ? ' - ' + payload?.endTime : ''),
                    link: payload?.linkAndPanel?.[0]?.link || AUTH_URL,
                    note: payload?.instructions || '',
                    signatureName: (userData?.first_name || '') + (userData?.last_name ? ' ' + userData?.last_name : ''),
                    signatureContact: userData?.phone_number || '',
                  }}
                />
              )
            } else {
              htmlBody = ReactDOMServer.renderToString(
                <OfflineScheduleTemplate
                  data={{
                    companyName: corporateData?.name,
                    roleName: rolesMetrics[0]?.roleName,
                    assessmentType: interviewLabel,
                    date: moment(dates[0]).format('DD/MMM/YYYY'),
                    time: (payload?.startTime || '') + (payload?.endTime ? ' - ' + payload?.endTime : ''),
                    venue: payload?.location || '',
                    note: payload?.instructions || '',
                    signatureName: (userData?.first_name || '') + (userData?.last_name ? ' ' + userData?.last_name : ''),
                    signatureContact: userData?.phone_number || '',
                  }}
                />
              )
            }
            return {
              to: item?.student?.studentPersonalProfile?.primaryEmail,
              subject: `${rolesMetrics[0]?.roleName} – ${isOnline ? 'Online ' : ''}${interviewLabel} Scheduled`,
              htmlBody,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }

        // WhatsApp: corporate_online for all online cases
        if (emailMode === 'EXTERNAL_LINK') {
          const waLabel = (interviewType === 'ASSESMENT' || interviewType === 'EXTERNAL_ASSESMENT')
            ? (typeLabels[interviewType] || 'Assessment')
            : (typeLabels[interviewType] || 'Interview')
          const waFinal = selectedCandidate
            ?.filter(item => item?.student?.studentPersonalProfile?.phoneNumber)
            .map(item => ({
            to: item?.student?.studentPersonalProfile?.phoneNumber,
            templateName: 'corporate_online',
            type: 'template',
            components: [
              {
                type: 'BODY',
                index: 0,
                sub_type: 'CATALOG',
                parameters: [
                  { type: 'TEXT', text: corporateData?.name || '' },
                  { type: 'TEXT', text: rolesMetrics[0]?.roleName || '' },
                  { type: 'TEXT', text: waLabel },
                  { type: 'TEXT', text: moment(dates[0]).format('DD/MM/YYYY') + ' - ' + moment(dates[1] || dates[0]).format('DD/MM/YYYY') },
                  { type: 'TEXT', text: (payload?.startTime || '') + (payload?.endTime ? ' - ' + payload?.endTime : '') },
                  { type: 'TEXT', text: payload?.linkAndPanel?.[0]?.link || AUTH_URL },
                  { type: 'TEXT', text: payload?.instructions || '' },
                ],
              },
            ],
          }))
          dispatch(sendNotificationBulkEmailWhatsapp(waFinal))
        }

        // WhatsApp: corporate_offline for all offline cases
        if (emailMode != 'EXTERNAL_LINK') {
          const waOfflineLabel = (interviewType === 'ASSESMENT' || interviewType === 'EXTERNAL_ASSESMENT')
            ? (typeLabels[interviewType] || 'Assessment')
            : (typeLabels[interviewType] || 'Interview')
          const waOfflineFinal = selectedCandidate
            ?.filter(item => item?.student?.studentPersonalProfile?.phoneNumber)
            .map(item => ({
              to: item?.student?.studentPersonalProfile?.phoneNumber,
              templateName: 'corporate_offline',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  index: 0,
                  sub_type: 'CATALOG',
                  parameters: [
                    { type: 'TEXT', text: corporateData?.name || '' },
                    { type: 'TEXT', text: rolesMetrics[0]?.roleName || '' },
                    { type: 'TEXT', text: waOfflineLabel },
                    { type: 'TEXT', text: moment(dates[0]).format('DD/MM/YYYY') },
                    { type: 'TEXT', text: (payload?.startTime || '') + (payload?.endTime ? ' - ' + payload?.endTime : '') },
                    { type: 'TEXT', text: payload?.location || '' },
                    { type: 'TEXT', text: payload?.instructions || '' },
                  ],
                },
              ],
            }))
          dispatch(sendNotificationBulkEmailWhatsapp(waOfflineFinal))
        }
      } else {
        handlePreview()
        setConfirmedResponse(response?.data?.data)
      }
      getMode()
      return true
    } else {
      setIsLoading(false)
      ErrorMessage(response?.response?.data?.message)
      return false
    }
  }
  const content = () => {
    return (
      <InterviewForm
        lastPanelId={lastPanelId}
        stage={stage}
        form={form}
        check={check}
        status={status}
        driveId={driveId}
        roleId={roleId}
        setCheck={setCheck}
        onEndTimeChange={onEndTimeChange}
        selectedCandidate={selectedCandidate}
        rolesMetrics={rolesMetrics}
        driveInterViewerList={driveInterViewerList}
        driveData={driveData}
        candidateDeatils={candidateDeatils}
        SelectedRoundName={selectedRoundName}
        interviewMode={interviewMode}
        isOneDayDrive={isOneDayDrive}
        linkPanelData={linkPanelData}
        setLinkPanelData={setLinkPanelData}
        addedInterviewer={addedInterviewer}
        interviewInfo={interviewInfo}
        isSingleOrBulk={isSingleOrBulk}
        handleIterviewRound={handleIterviewRound}
        disabledDate={disabledDate}
        onChangeDate={onChangeDate}
        onDurationChange={onDurationChange}
        onTimeChange={onTimeChange}
        onChangeMode={onChangeMode}
        onChangeLink={onChangeLink}
        onClickNone={onClickNone}
        onSelectInterview={onSelectInterview}
        onSubmitFormData={onSubmitFormData}
        interviewType={interviewType}
        dateFormat={dateFormat}
        candidates={candidates}
        setCandidates={setCandidates}
        selectedRoundType={selectedRoundType}
        preview={preview}
        disabledStartDate={disabledStartDate}
        disabledEndDate={disabledEndDate}
        onChangeStartDate={onChangeStartDate}
        onChangeEndDate={onChangeEndDate}
        selectingStartDate={selectingStartDate}
        selectingEndDate={selectingEndDate}
        isAssesemntType={isAssesemntType}
        dateRange={dateRange}
        interviewList={interviewList}
        getUpdatedList={getUpdatedList}
        inteviewer={interviewer}
        isBulk={isAllSelected}
        parametersList={parametersList}
        setParametersList={setParametersList}
        getCandidateScoreList={getCandidateScoreList}
      />
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          onClick={() => {
            setPreview(false)
            setScheduleDrawer(false)
            form.resetFields()
            setInterviewInfo({})
            form.setFieldsValue({ interviewRound: selectedRoundName })

            setSelectingStartDate('')
            setSelectingEndDate('')
            setDateRange([])
            getMode()
            setLinkPanelData([
              {
                link: '',
                panel: [{ id: null, firstName: null, lastName: null }],
              },
            ])
          }}
          width="88px"
          height="38px"
          text="Cancel"
        />

        <Button.Primary
          height="38px"
          text={'Preview & Schedule'}
          form={'scheduleForm'}
          htmlType={'submit'}
          loading={isLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="43%"
        title={'Schedule'}
        placement="right"
        visible={scheduleDrawer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setPreview(false)
          setScheduleDrawer(false)
          setCandidates(0)
          form.setFieldsValue({
            candidatesPerGroup: 0,
          })
          form.resetFields()
          setInterviewInfo({})
          form.setFieldsValue({ interviewRound: selectedRoundName })
          form.setFieldsValue({ mode: interviewMode })
          setSelectingStartDate('')
          setSelectingEndDate('')
          setDateRange([])
          getMode()
          setLinkPanelData([
            {
              link: '',
              panel: [{ id: null, firstName: null, lastName: null }],
            },
          ])
        }}
        closable
      />
      {schedulePreview && (
        <ManyToManyPreview
          lastPanelId={lastPanelId}
          schedulePreview={schedulePreview}
          setSchedulePreview={setSchedulePreview}
          confirmedResponse={confirmedResponse}
          interviewType={interviewType}
          setScheduleDrawer={setScheduleDrawer}
          setPrivew={setPreview}
        />
      )}
      {preview && (
        <OneToOnePreview
          lastPanelId={lastPanelId}
          interviewType={interviewType}
          interviewInfo={interviewInfo}
          driveInterViewerList={driveInterViewerList}
          isSingleOrBulk={isSingleOrBulk}
          selectedCandidate={selectedCandidate}
          setScheduleDrawer={setScheduleDrawer}
          setPrivew={setPreview}
          scheduleInterview={scheduleInterview}
          preview={preview}
          isOneDayDrive={isOneDayDrive}
          setInterviewType={setInterviewType}
          isLoading={isLoading}
          candidateInfoData={candidateInfoData}
          confirmedResponse={confirmedResponse}
          count={candidateDeatils?.notDisabledCount}
          inteviewer={interviewer}
          isBulk={
            isAllSelected
            // selectedCandidate?.length === 10 ||
            // selectedCandidate?.length === candidateDeatils?.count
          }
          selectedRoundType={selectedRoundType}
        />
      )}
    </>
  )
}

export default ScheduleInterview
